import { render, staticRenderFns } from "./TransportRejected.vue?vue&type=template&id=5298ae89"
import script from "./TransportRejected.vue?vue&type=script&lang=js"
export * from "./TransportRejected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports